/* A sub's schedule of values (2026-10-29), as both its Billing tab (subs/SubBilling.js) and Task Properties' Sub SOV
   links (TaskSubSovLinks.js) number it: the lines with no section first (when there are sections), then each
   section's in order, numbered down the page as a schedule of values reads. */

/** { groups: [{ section | null, lines }], lines } -- each line with its `number`. */
export function numberLines(lines, sections) {
  const groups = [];
  const loose = lines.filter((l) => !l.section_id || !sections.some((x) => x.id === l.section_id));
  if (loose.length || !sections.length) groups.push({ section: null, lines: loose });
  sections.forEach((x) => groups.push({ section: x, lines: lines.filter((l) => l.section_id === x.id) }));
  let n = 0;
  const numbered = groups.map((g) => ({ ...g, lines: g.lines.map((l) => ({ ...l, number: (n += 1) })) }));
  return { groups: numbered, lines: numbered.flatMap((g) => g.lines) };
}
